import { create } from 'zustand';
import { NavItemType } from 'types/menu';

interface MenuState {
  items: NavItemType[];
  setItems: (items: NavItemType[]) => void;
  clearItems: () => void;
}

/** Menú dinámico — se carga desde la API en cada login, no persiste */
export const useMenuStore = create<MenuState>()((set) => ({
  items: [],
  setItems: (items) => set({ items }),
  clearItems: () => set({ items: [] }),
}));
